import React, { useEffect, useState } from 'react';
import { ApolloClient, useMutation } from '@apollo/client';
import { GET_ORGANIZATION } from 'Shared/api/queries/getOrganization.query';
import { GET_ALL_PARTICIPANTS_QUERY } from 'Shared/api/queries/getParticipants.query';
import { IMPERSONATE } from '../api/queries/queries_local';

export const ADMIN_LEVEL = 'Admin';

export const impersonateHeader = (useAdminToken) => ({
  context: {
    headers: {
      'x-ibinder-impersonate': useAdminToken
    }
  }
});

export const impersonateAdminnHeader = (useAdminToken) => ({
  context: {
    headers: {
      'x-ibinder-organization-impersonate': useAdminToken
    }
  }
});

function useImpersonateAdmin(
  client: ApolloClient<object>,
  organizationId: string
): any[] {
  const [useAdminToken, setUseAdminToken] = useState('');
  const [runImpersonate] = useMutation(IMPERSONATE);

  useEffect(() => {
    if (!organizationId) return;

    // Set selected organizations tenant id in localstorage so authLink can accesss it
    localStorage.setItem('tenantId', organizationId);

    const getData = async () => {
      const organization = await client.query({
        query: GET_ORGANIZATION,
        variables: {
          organizationId
        }
      });

      const firstAdmin = organization.data?.get.admins[0];

      const response = await runImpersonate({
        variables: {
          input: { targetUserId: firstAdmin.userId }
        }
      });

      setUseAdminToken(response.data.post.impersonationToken);
    };

    getData();
  }, [organizationId]);

  return [useAdminToken];
}

export default useImpersonateAdmin;
